import { z } from 'zod';

// Utility schema definitions
export const urlSchema = z.string().url();
export const pathSchema = z.string().startsWith('/');
export const emptyStringSchema = z.literal('');

// Combined schemas for reuse
export const pathOrUrl = z.union([pathSchema, urlSchema]);
export const pathOrUrlOrEmpty = z.union([pathSchema, urlSchema, emptyStringSchema]);
